import * as React from "react";
const SvgPlaneLand = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 19.898a1 1 0 1 1 0 2H3a1 1 0 0 1 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.365 2.126c.245-.202.57-.275.878-.199l.03.008c.642.16 1.204.287 1.666.593.379.25.696.584.927.975.282.477.381 1.044.51 1.692l.96 4.858 5.758 1.44a3.05 3.05 0 0 1 2.155 3.923 2.025 2.025 0 0 1-2.412 1.324L4.182 13.076c-.776-.194-1.457-.345-1.98-.737a3 3 0 0 1-.968-1.239C.981 10.498 1 9.802 1 9.002V5.5a1.002 1.002 0 0 1 1.243-.971c.365.091.633.157.883.254A4 4 0 0 1 5.28 6.778c.116.241.201.504.32.861l.175.523 2.53.632-.303-5.843a1 1 0 0 1 .363-.825m5.616 11.18q.014.082.017.162l5.324 1.331.009.001a.03.03 0 0 0 .016-.008l.004-.008a1.05 1.05 0 0 0-.741-1.35l-4.844-1.212zm-3.482-.858a1 1 0 0 1-.005.144l1.375.343-1.456-7.352c-.157-.794-.202-.95-.268-1.062a1 1 0 0 0-.063-.096zm-7.5-3.446c0 .985.02 1.183.079 1.324.069.164.18.306.323.413.122.091.31.157 1.266.396l3.81.953-.062-1.204-3.657-.914a1 1 0 0 1-.708-.653l-.347-1.045c-.136-.407-.177-.527-.226-.628A2 2 0 0 0 3 7.015z",
  clipRule: "evenodd"
}));
export default SvgPlaneLand;
//# sourceMappingURL=PlaneLand.js.map